<template>
  <v-container>
    <v-row no-gutters class="manage-account-container">
      <v-col cols="12" md="1">
        <router-link to="/overview" class="back-arrow"
          ><v-icon large color="mid-grey" class="mt-1">{{
            icons.mdiArrowLeft
          }}</v-icon></router-link
        >
      </v-col>
      <v-col cols="12" md="3" class="form-blurb mb-12">
        <h1>Manage my account</h1>
      </v-col>
      <v-col cols="12" md="5" offset-md="2" class="mt-4">
        <div v-if="!loading">
          <div v-if="whitelabel.authentication.signUp.showEmail">
            <h3>Email</h3>
            <UpdateEmail :testator-email="testator.email" />
          </div>

          <div v-if="isAdvisor">
            <h3>Advisor Code</h3>
            <UpdateAdvisorCode :advisorCode="testator.user.advisorCode" />
          </div>

          <div v-if="whitelabel.authentication.signUp.showUniqueIdentifier">
            <h3>Industry Number</h3>
            <UpdateUniqueIdentifier
              :testator-unique-identifier="testator.uniqueIdentifier"
            />
          </div>

          <div
            v-if="
              isMigratedFromTeba &&
              whitelabel.authentication.signUp.showUniqueIdentifier
            "
          >
            <h3>Email</h3>
            <UpdateEmail :testator-email="testator.email || ''" />
          </div>

          <div v-if="whitelabel.authentication.signUp.showPhone">
            <h3>Phone</h3>
            <UpdatePhone :testator-phone="testator.phone" />
          </div>

          <h3>Password</h3>
          <UpdatePassword />

          <h3>Delete account</h3>
          <DeleteAccount />

          <!-- <h3>Advisor</h3>
          <InviteAdvisor :testator="testator" /> -->
        </div>

        <div v-else class="text-center">
          <v-progress-circular indeterminate color="primary" />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import UpdateEmail from './UpdateEmail.vue';
  import UpdateUniqueIdentifier from './UpdateUniqueIdentifier.vue';
  import UpdatePhone from './UpdatePhone.vue';
  import UpdatePassword from './UpdatePassword.vue';
  import DeleteAccount from './DeleteAccount.vue';
  import UpdateAdvisorCode from './UpdateAdvisorCode.vue';
  import InviteAdvisor from './InviteAdvisor.vue';
  import { TESTATOR_QUERY } from '../../constants/graphql/testators';

  export default {
    name: 'ManageAccount',
    components: {
      UpdateEmail,
      UpdateUniqueIdentifier,
      UpdatePhone,
      UpdatePassword,
      DeleteAccount,
      UpdateAdvisorCode,
      InviteAdvisor,
    },
    data() {
      return {
        loading: true,
        testator: {},
      };
    },
    created() {
      if (this.isLoggedInAsSomeoneElse) {
        this.$router.push('/overview');
      }
    },
    computed: {
      isAdvisor() {
        return this.$store.getters.isAdvisor;
      },
      isMigratedFromTeba() {
        return !!this.testator?.user?.migratedFromTeba;
      },
    },
    apollo: {
      testator: {
        query: TESTATOR_QUERY,
        variables() {
          return {
            id: this.testatorId,
          };
        },
        skip() {
          return this.isLoggedInAsSomeoneElse;
        },
        result(response) {
          if (response.data.testator) this.loading = false;
        },
      },
    },
  };
</script>
<style lang="scss" scoped>
  .manage-account-container {
    margin: 48px 12px;
  }
  h1 {
    line-height: 38px;
  }
</style>
